 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML02_COPYRIGHT from '@/components/xhtml/02_Copyright'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML01_TITLE_PAGE from '@/components/xhtml/01_Title_Page'
 import XHTML03_CONTENTS from '@/components/xhtml/03_Contents'
 import XHTML04_ACKNOWLEDGMENTS from '@/components/xhtml/04_Acknowledgments'
 import XHTML05_INTRODUCTION from '@/components/xhtml/05_Introduction'
 import XHTML06_1__THE_POLITICAL_THEOLOGY_OF_LAT from '@/components/xhtml/06_1__The_Political_Theology_of_Lat'
 import XHTML07_2__THE_POLITICAL_AND_THE_ECONOMI from '@/components/xhtml/07_2__The_Political_and_the_Economi'
 import XHTML08_3__NEOLIBERALISM_S_DEMONS from '@/components/xhtml/08_3__Neoliberalism_s_Demons'
 import XHTML09_4__THIS_PRESENT_DARKNESS from '@/components/xhtml/09_4__This_Present_Darkness'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML10_CONCLUSION__AFTER_NEOLIBERALISM from '@/components/xhtml/10_Conclusion__After_Neoliberalism'
 import XHTML11_NOTES from '@/components/xhtml/11_Notes'
 import XHTML12_BIBLIOGRAPHY from '@/components/xhtml/12_Bibliography'
 import XHTML13_INDEX from '@/components/xhtml/13_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/03_Contents",
 			"name" : "xhtml/03_Contents",
 			"component" : XHTML03_CONTENTS
 		},
 		{
 			"path" : "/xhtml/04_Acknowledgments",
 			"name" : "xhtml/04_Acknowledgments",
 			"component" : XHTML04_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/xhtml/05_Introduction",
 			"name" : "xhtml/05_Introduction",
 			"component" : XHTML05_INTRODUCTION
 		},
 		{
 			"path" : "/xhtml/06_1__The_Political_Theology_of_Lat",
 			"name" : "xhtml/06_1__The_Political_Theology_of_Lat",
 			"component" : XHTML06_1__THE_POLITICAL_THEOLOGY_OF_LAT
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js